export default {"src":"/_next/static/media/bookmark.e4f009e2.svg","height":32,"width":34,"blurWidth":0,"blurHeight":0};